import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  constructor() { }

  getHeaderWithToken(userToken: any) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + userToken);
    return headers;
  }
  getHeaderWithTokenWithOutContentType(userToken: any) {
    let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + userToken);
    return headers;
  }

  getHeaderWithoutToken() {
    const httpHeader = new HttpHeaders();
    httpHeader.set('Content-Type', 'application/json');
    httpHeader.set('Accept', 'application/json');
    return httpHeader;
  }
}
